// extracted by mini-css-extract-plugin
export default {"LoginWrapper":"Register_LoginWrapper__YaTC+","logo":"Register_logo__aVZ4X"};